import EDNetze from '../img/ed-netze.jpg';
import Hegauwind from '../img/hegauwind.png';
import Solarcomplex from '../img/solarcomplex.jpg';
import AmpereCloud from '../img/ampere-cloud.webp';

export const Footer = () => {
  return (
    <footer className='overflow-hidden w-100 d-flex justify-content-center '>
      <div className='row justfiy-content-center footer-container'>
        <div className='col-sm-6 col-md-3 logo-container'>
          <a
            href='https://ampere.cloud/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={AmpereCloud}
              alt='Ampere Cloud'
              className='footer-img1'
              draggable='false'
            />
          </a>
        </div>

        <div className='col-sm-6 col-md-3 logo-container'>
          <a
            href='https://www.solarcomplex.de/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={Solarcomplex}
              alt='Solarcomplex'
              className='footer-img2'
              draggable='false'
            />
          </a>
        </div>

        <div className='col-sm-6 col-md-3 logo-container'>
          <a
            href='https://www.ednetze.de/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={EDNetze}
              alt='EDNetze'
              className='footer-img1'
              draggable='false'
            />
          </a>
        </div>

        <div className='col-sm-6 col-md-3 logo-container'>
          <a
            href='https://www.verenafohren.de/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={Hegauwind}
              alt='Hegauwind'
              className='footer-img2'
              draggable='false'
            />
          </a>
        </div>
      </div>
    </footer>
  );
};
